import { DELETE_DRAFT_ENDPOINT, DRAFTS_ENDPOINT } from '../endpoints/draft'
import deleteRequest from '../request/deleteRequest'

export default async id => {
  try {
    const response = await deleteRequest({
      url: `${DELETE_DRAFT_ENDPOINT}/${id}`
    })
    const { data } = response.data
    const status = response.status
      
    alert(data)
  } catch (error) {
    const { data } = error.response.data
    const status = error.response.status
      
    alert(data)
  }
}
